export default __webpack_public_path__ + "static/media/22.84e61341.png";